
import { ToastModel } from "@/interfaces/app/toast-model";
import store from "@/store";
import { defineComponent } from "vue";

const TOAST_DURATION = 5000;

export default defineComponent({
    name: "ToastComponent",
    props: {
        toast: {
            type: Object as () => ToastModel,
            required: true
        }
    },
    data() {
        return {
            duration: TOAST_DURATION
        };
    },
    computed: {
        isError(): boolean {
            return ["danger", "error"].includes(this.toast.type);
        },
        tone(): { title: string; symbol: string; border: string; icon: string; progress: string } {
            const tones: Record<string, { title: string; symbol: string; border: string; icon: string; progress: string }> = {
                success: {
                    title: "عملیات موفق",
                    symbol: "mdi-check",
                    border: "border-emerald-200",
                    icon: "bg-emerald-50 text-emerald-700",
                    progress: "bg-emerald-500"
                },
                warning: {
                    title: "توجه",
                    symbol: "mdi-alert",
                    border: "border-amber-200",
                    icon: "bg-amber-50 text-amber-700",
                    progress: "bg-amber-500"
                },
                info: {
                    title: "اطلاع‌رسانی",
                    symbol: "mdi-information",
                    border: "border-sky-200",
                    icon: "bg-sky-50 text-sky-700",
                    progress: "bg-sky-500"
                },
                danger: {
                    title: "عملیات ناموفق",
                    symbol: "mdi-alert-circle",
                    border: "border-rose-200",
                    icon: "bg-rose-50 text-rose-700",
                    progress: "bg-rose-500"
                },
                error: {
                    title: "خطا",
                    symbol: "mdi-alert-circle",
                    border: "border-rose-200",
                    icon: "bg-rose-50 text-rose-700",
                    progress: "bg-rose-500"
                }
            };
            return tones[this.toast.type] || tones.info;
        }
    },
    methods: {
        dismiss(): void {
            store.dispatch("app/dismissToast");
        }
    }
});
